export const NEWS_DETAIL = 'NEWS_DETAIL';
